module.exports = __webpack_public_path__ + "img/google_play.e6d552c5.png";